
import lusiane from '../img/home/Lusine_Arutunyan.jpg';
import img1 from '../img/home/img1.jpeg';
import img2 from '../img/home/img2.jpeg';
import img3 from '../img/home/img3.jpeg';
import img4 from '../img/home/img4.jpeg';

 const texts = [
        {
        "title":`I'm Lusine Photographer`,
        "subtitle": "Marseille-Paris, France",
        "images":  lusiane
        },
        {
        "title":"I make Maternity Magic Memories",
        "subtitle": "Pregnancy Photography",
        "images":  img1
        },
        {
        "title":"I capture Wedding Day Moments",
        "subtitle": "Weddings Photography",
        "images":  img2
        },
        {
        "title":"Take some Happy Family Captures",
        "subtitle": "Familiar Photography",
        "images":  img3
        },
        {
        "title":"Chic Image Creation",
        "subtitle": "Fashion Photography",
        "images":  img4
        },
 ]
 export default texts